import { CustomDialog } from '../../../components';
import React, { useState } from 'react';
import * as yup from 'yup';
import { useFormWithSchema } from '../../../utils/functions/yupFormTypescript';
import { useInsertOrUpdateRequestInspectionMutation } from '../../../services/mVPGraphQlService';

import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../store';
import { showAlert } from '../../../services/alert';

type MVPFiltersProps = {
  open: boolean;
  setOpen: (open: boolean) => void;
  seletedIds: number[];
  setSeletedIds?: (ids: number[]) => void;
  fromDataTable?: boolean;
  refetch?: any;
};

export const InspectionRequest: React.FC<
  MVPFiltersProps
> = ({
  open,
  setOpen,
  seletedIds,
  setSeletedIds,
  fromDataTable,
  refetch,
}) => {
  const [charCount, setCharCount] = useState(0);
  const formSchemaModal = yup.object({
    feedback: yup
      .string()
      .required('Feedback is required')
      .max(300, 'Feedback cannot exceed 300 characters'),
  });
  const dispatch = useDispatch();
  const {
    formState: { errors: err },
    handleSubmit,

    register: reg,
    watch: wat,
    reset,
  } = useFormWithSchema(formSchemaModal, {
    mode: 'onTouched',
  });
  const user = useSelector(
    (state: RootState) => state.authUser
  );
  const wsId = useSelector(
    (state: RootState) => state.country.wsId
  );
  const [insertOrUpdateRequest] =
    useInsertOrUpdateRequestInspectionMutation();
  const onSubmit = (data: { feedback: string }) => {
    const obj = {
      fieldNumbers: seletedIds,
      reqInstructions: data.feedback,

      actor: {
        actorId: user?.userId,
        actorName: user?.userName,
        actorType: user?.role,
      },
      wsId: wsId,
    };

    insertOrUpdateRequest(obj)
      .unwrap()
      .then((response) => {
        const inspectionData =
          response?.data?.InsertOrUpdateRequestInspection;

        if (
          inspectionData?.responseStatus?.status ===
          'SUCCESS'
        ) {
          if (inspectionData.updatedInspectionsCount > 0) {
            reset();
            fromDataTable && setSeletedIds([]);
            dispatch(
              showAlert({
                content: `${inspectionData.updatedInspectionsCount} inspection requests sent successfully`,
                severity: 'success',
              })
            );
            fromDataTable && refetch();
          }

          if (inspectionData?.errorList?.length > 0) {
            inspectionData.errorList.forEach((element) => {
              dispatch(
                showAlert({
                  content: element.errorMessage,
                  severity: 'error',
                })
              );
              fromDataTable && setSeletedIds([]);
            });
          }
        } else {
          dispatch(
            showAlert({
              content: 'Something went wrong',
              severity: 'error',
            })
          );
        }
      })

      .catch((err) => {
        console.error('Error:', err);
        dispatch(
          showAlert({
            content: 'something went wrong2',
            severity: 'error',
          })
        );
      });
  };

  return (
    <CustomDialog
      dialogTitle={'Request inspection'}
      open={open}
      setOpen={setOpen}
      onSubmit={handleSubmit((data) => onSubmit(data))}
      actionText={{ submit: 'Save', cancel: 'Cancel' }}
      disableAccept={!wat('feedback') || charCount > 300}
      maxWidth="sm">
      <form
        onSubmit={handleSubmit((data) => onSubmit(data))}
        className="mb-10 pb-20">
        <div>
          {' '}
          You have selected {seletedIds?.length} fields{' '}
        </div>
        <div> Instructions (maximum 300 characters) </div>
        <div style={{ marginTop: 10 }}></div>

        <textarea
          id="feedback"
          {...reg('feedback', {
            required: 'Feedback are required',

            maxLength: {
              value: 300,
              message:
                'Feedback cannot exceed 300 characters',
            },
          })}
          rows={4}
          className={`w-full px-3 py-2 border rounded-md shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
            err.feedback
              ? 'border-red-500'
              : 'border-gray-300'
          }`}
          placeholder="Write something"
          onChange={(e) => {
            reg('feedback').onChange(e);
            setCharCount(e.target.value.length);
          }}
        />
        <div className="flex justify-between mt-1">
          <div className="text-sm text-red-500">
            {err.feedback?.message}
          </div>
          <div
            className={`text-sm ${
              charCount > 300
                ? 'text-red-500'
                : 'text-gray-500'
            }`}>
            {charCount}/300 characters
          </div>
        </div>
      </form>
    </CustomDialog>
  );
};
